<template>
    <span>
        <p class="transparent-circle" v-if="line.shape.line == 'circle_a' && pos.angle == 'up'"
            :style="{
                top: (line.top - 4) + 'px',
                left: (line.left - 32) + 'px'
            }">
        </p>
        <p class="transparent-circle" v-if="line.shape.line == 'circle_a' && pos.angle == 'down'"
            :style="{
                top: (line.top + line.height - 66) + 'px',
                left: (line.left - 32) + 'px'
            }">
        </p>
        <p class="transparent-circle" v-if="line.shape.line == 'circle_b' && pos.angle == 'up'"
            :style="{
                top: (line.top - 69) + 'px',
                left: (line.left - 32) + 'px'
            }">
        </p>
        <p class="transparent-circle" v-if="line.shape.line == 'circle_b' && pos.angle == 'down'"
            :style="{
                top: (line.top + line.height - 1) + 'px',
                left: (line.left - 32) + 'px'
            }">
        </p>
        <svg class="strong down" height="45" width="50" v-if="line.shape.line == 'strong_a' && pos.angle == 'up'"
            :style="{
                top: (line.top - 44) + 'px',
                left: (line.left - 22) + 'px'
            }">
            <line x1="0" y1="-5" x2="25" y2="45" />
            <line x1="50" y1="-5" x2="24" y2="45" />
            Sorry, your browser does not support inline SVG.
        </svg>
        <svg class="strong up" height="45" width="50" v-if="line.shape.line == 'strong_a' && pos.angle == 'down'"
            :style="{
                top: (line.top + line.height - 1) + 'px',
                left: (line.left + 2) + 'px'
            }">
            <line x1="0" y1="-5" x2="25" y2="45" />
            <line x1="50" y1="-5" x2="24" y2="45" />
            Sorry, your browser does not support inline SVG.
        </svg>
        <svg class="strong up" height="45" width="50" v-if="line.shape.line == 'strong_b' && pos.angle == 'up'"
            :style="{
                top: (line.top - 6) + 'px',
                left: (line.left + 2) + 'px'
            }">
            <line x1="0" y1="-5" x2="25" y2="45" />
            <line x1="50" y1="-5" x2="24" y2="45" />
            Sorry, your browser does not support inline SVG.
        </svg>
        <svg class="strong down" height="45" width="50" v-if="line.shape.line == 'strong_b' && pos.angle == 'down'"
            :style="{
                top: (line.top + line.height - 39) + 'px',
                left: (line.left - 22) + 'px'
            }">
            <line x1="0" y1="-5" x2="25" y2="45" />
            <line x1="50" y1="-5" x2="24" y2="45" />
            Sorry, your browser does not support inline SVG.
        </svg>

        <svg class="medium up" height="35" width="70" alt="Medium" v-if="line.shape.line == 'medium_a' && pos.angle == 'up'"
            :style="{
                top: (line.top + line.height - 1) + 'px',
                left: (line.left + 2) + 'px'
            }">
            <line x1="-1" y1="-5" x2="36" y2="35" />
            <line x1="71" y1="-5" x2="33" y2="35" />
            Sorry, your browser does not support inline SVG.
        </svg>
        <svg class="medium down" height="35" width="70" alt="Medium" v-if="line.shape.line == 'medium_a' && pos.angle == 'down'"
            :style="{
                top: (line.top - 33) + 'px',
                left: (line.left - 32) + 'px'
            }">
            <line x1="-1" y1="-5" x2="36" y2="35" />
            <line x1="71" y1="-5" x2="33" y2="35" />
            Sorry, your browser does not support inline SVG.
        </svg>
        <svg class="medium up" height="35" width="70" alt="Medium" v-if="line.shape.line == 'medium_b' && pos.angle == 'up'"
            :style="{
                top: (line.top - 5) + 'px',
                left: (line.left + 2) + 'px'
            }">
            <line x1="-1" y1="-5" x2="36" y2="35" />
            <line x1="71" y1="-5" x2="33" y2="35" />
            Sorry, your browser does not support inline SVG.
        </svg>
        <svg class="medium down" height="35" width="70" alt="Medium" v-if="line.shape.line == 'medium_b' && pos.angle == 'down'"
            :style="{
                top: (line.top + line.height - 30) + 'px',
                left: (line.left - 32) + 'px'
            }">
            <line x1="-1" y1="-5" x2="36" y2="35" />
            <line x1="71" y1="-5" x2="33" y2="35" />
            Sorry, your browser does not support inline SVG.
        </svg>

        <svg class="weak down" height="20" width="80" alt="Weak" v-if="line.shape.line == 'weak_a' && pos.angle == 'down'"
            :style="{
                top: (line.top - 19) + 'px',
                left: (line.left - 37) + 'px'
            }">
            <line x1="-2" y1="-5" x2="42" y2="20" />
            <line x1="83" y1="-5" x2="37" y2="20" />
            Sorry, your browser does not support inline SVG.
        </svg>
        <svg class="weak up" height="20" width="80" alt="Weak" v-if="line.shape.line == 'weak_a' && pos.angle == 'up'"
            :style="{
                top: (line.top + line.height - 1) + 'px',
                left: (line.left + 2) + 'px'
            }">
            <line x1="-2" y1="-5" x2="42" y2="20" />
            <line x1="83" y1="-5" x2="37" y2="20" />
            Sorry, your browser does not support inline SVG.
        </svg>
        <svg class="weak down" height="20" width="80" alt="Weak" v-if="line.shape.line == 'weak_b' && pos.angle == 'down'"
            :style="{
                top: (line.top + line.height - 16) + 'px',
                left: (line.left -37) + 'px'
            }">
            <line x1="-2" y1="-5" x2="42" y2="20" />
            <line x1="83" y1="-5" x2="37" y2="20" />
            Sorry, your browser does not support inline SVG.
        </svg>
        <svg class="weak up" height="20" width="80" alt="Weak" v-if="line.shape.line == 'weak_b' && pos.angle == 'up'"
            :style="{
                top: (line.top - 4) + 'px',
                left: (line.left + 2) + 'px'
            }">
            <line x1="-2" y1="-5" x2="42" y2="20" />
            <line x1="83" y1="-5" x2="37" y2="20" />
            Sorry, your browser does not support inline SVG.
        </svg>

        <svg class="horizontal" height="10" width="81" v-if="line.shape.line == 'horizontal' && pos.angle == 'up'"
            :style="{
                top: (line.top - 4) + 'px',
                left: (line.left - 39) + 'px'
            }">
            <line x1="0" y1="0" x2="81" y2="0" />
            Sorry, your browser does not support inline SVG.
        </svg>

        <svg class="horizontal" height="10" width="81" v-if="line.shape.line == 'horizontal' && pos.angle == 'down'"
            :style="{
                top: (line.top + line.height - 1) + 'px',
                left: (line.left - 39) + 'px'
            }">
            <line x1="0" y1="0" x2="81" y2="0" />
            Sorry, your browser does not support inline SVG.
        </svg>
    </span>
</template>
<script>
export default {
  name: 'line-shape',
  props: ['pos', 'line']
}
</script>
